import { render, staticRenderFns } from "./menuDown.vue?vue&type=template&id=21fd97ee&"
import script from "./menuDown.vue?vue&type=script&lang=js&"
export * from "./menuDown.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports